const ak = 'W9rQ6gMRGATumnM97EuJZ24n5VdcJEi4'
/**
 * 异步加载百度地图
 * @returns {Promise}
 * @constructor
 */
const loadBaiDuMap = () => {
  return new Promise((resolve, reject) => {
    try {
      resolve(BMapGL)
    } catch (err) {
      window.initialize = () => {
        console.log('地图组件初始化成功', BMapGL);
        resolve(BMapGL)
      }
      const script = document.createElement('script')
      script.src = `https://api.map.baidu.com/api?v=1.0&type=webgl&ak=${ak}&callback=initialize`
      script.onerror = reject
      document.body.appendChild(script)
    }
  })
}
export { loadBaiDuMap }
/**
 * 选择性加载，如果不需要就把下面的这部分删掉
 * 异步加载百度地图,以及绘制工具
 * @returns {Promise}
 * @constructor
 */
const loadBaiDuDrawMap = async () => {
  const BMapGL = await loadBaiDuMap()
  let loaded = false
  try {
    loaded = BMapGLLib && BMapGLLib.DrawingManager
  } catch (err) {
    loaded = false
  }
  console.log('加载', loaded)
  return BMapGL
}
export { loadBaiDuDrawMap }
